module.exports = __webpack_public_path__ + "img/geomembranaPead1.2be5f66b.png";